// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_g3-0";
export var optionCard = "_g3-1";